import React from "react";
import styled from "styled-components";
import TextInput, { TextInputProps } from "components/common/ui/TextInput/TextInput";

export const InputLabel = styled.p`
    font-size: 16px;
    font-weight: 400;
    margin: 0.5rem 0 0 0;
`;

const StyledTextInput = styled(TextInput)`
    font-size: 16px;
`;

interface FeatureRequestInputProps extends Omit<TextInputProps, "onChange"> {
    label: string;
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
}

const FeatureRequestInput: React.FC<FeatureRequestInputProps> = ({ label, ...rest }) => (
    <div>
        <InputLabel>{label}</InputLabel>
        <StyledTextInput {...rest} />
    </div>
);

export default FeatureRequestInput;
